import { InjectionToken } from "@angular/core";
import { IConnectionCodeStateService } from "./i-connection-code-state.service";

export const connectionCodeStateServiceInjectionToken: InjectionToken<IConnectionCodeStateService> = new InjectionToken<IConnectionCodeStateService>("digital-signage.user-dashboard.dashboard-web.ConnectionCodeStateService")
